package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.Character
import fr.manyverse.app.domain.repository.CharacterRepository
import fr.manyverse.app.domain.repository.ImageStorageRepository

class GetCharacterByIdUseCase(
    private val characterRepository: CharacterRepository,
    private val imageStorageRepository: ImageStorageRepository
) {
    suspend operator fun invoke(
        characterId: String
    ): Result<Character?> {
        return characterRepository.getCharacterById(characterId)
            .map { character ->
                if (character?.imageUrl != null) {
                    val signedUrlResult = imageStorageRepository.getSignedUrl(
                        character.imageUrl,
                        version = character.updatedAt.toString()
                    )
                    if (signedUrlResult.isSuccess) {
                        character.copy(signedImageUrl = signedUrlResult.getOrThrow())
                    } else {
                        character
                    }
                } else {
                    character
                }
            }
    }
}
